/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmObsahLicCert extends GContentBase<SeznamAdmObsahLicCertObj> {
        private seznamObj: SeznamAdmObsahLicCertObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmObsahLicCertObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmObsahLicCert",
                contentCaption: "jres:33000242", //RC 33000242 : Přehled licencí
                dataListDescriptor: this.dataListDescription,
                filterSettings: {
                    createFilter: false,
                },
                comparatorSettings: {
                    itemTemplate: "{pol} - {ppol}"
                },
                gridSettings: {
                    columnOrder: "lic,pol,ppol,rezim_lic_txt,popis,pocet,faze,pocet_lic,pocet_adm,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createGrid();
            this.seznamObj.applydata({});
        }

        onClose() {
            this.seznamObj.closeAction();
        }
    }

    export class SeznamAdmObsahLicCertObj extends GAdmSeznamBase {
        private temporaryFiles: string[];
        private serviceCnt: GContent;
        create() {
            this.temporaryFiles = [];
        }

        openDetail(data: any, isNew: boolean) {
           
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenUploadLic: {
                    caption: "jres:33000238", //RC 33000238 : Nahrát licenční certifikát
                    icon: "gi-certif",
                    run: (ev, ctx) => {
                        this.openUploadLicCer();
                    }
                },
                actLicCerDialogOk: {
                    caption: "jres:33000243", //RC 33000243 : OK
                    customClass: "g-button--primary",
                    run: (ev, ctx) => {
                        this.licCerDialogOk(ev);
                    }
                },
                actCloseDerDialog: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        $.content(ev.target).close();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actAddToComparison*", "actOpenUploadLic*"]))
        }

        createContextMenu(): MenuParams[] {
            return [];
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmObsahLicCert.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }
        

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "",
                nazev: ""
            }
        }

        closeAction() {
            this.getServiceCnt().fire("ClearTemporaryFiles", { files: this.temporaryFiles })
        }

        private getServiceCnt(): GContent {
            if (this.serviceCnt == null || this.serviceCnt != undefined)
                this.serviceCnt = this.cnt.createServiceContent("Gordic.Adm.WebControls.SeznamAdmObsahLicCert");
            return this.serviceCnt;
        }

        private openUploadLicCer() {
            var form = new Gordic.Forms.Form()
                .addRow("jres:33000241").addField("gfilefield", { //RC 33000241 : Licenční certifikát
                    name: "lic_cer_file",
                    acceptExtension: ".pdf",
                    fileUploaded: (ev, fileInfo) => {
                        if (fileInfo.fileInfo.guid)
                            this.temporaryFiles.push(fileInfo.fileInfo.guid);
                    }
                })

            this.cnt.dialogs.simpleForm("jres:33000239", form, null, { //RC 33000239 : Nahrání licenčního certifikátu
                height: 200,
                commandBar: [{
                    action: this.cnt.actions.actLicCerDialogOk,
                }, {
                    action: this.cnt.actions.actCloseDerDialog
                }]
            })
        }

        private licCerDialogOk(ev: JQueryEventObject) {
            var cnt = $.content(ev.target);
            var value = cnt.findFields("lic_cer_file").gfield("getValue");
            if (value) {
                if (value.length > 0) {
                    var inputValue: AdmIsl.Interface.GAdmLicencniCertifikatDto = {
                        file: value[0]
                    }
                    this.initAsyncTask();
                    Gordic.Async.GTaskManager.start("Gordic.AdmIsl.Server.LoadLicencniCertifikatAsync", inputValue)
                    cnt.close();
                }
            }
        }

        private initAsyncTask() {
            var registerClass = "Gordic.AdmIsl.Server.LoadLicencniCertifikatAsync";
            if (Async.GTaskManager.getAllTasks().find(item => item.className == registerClass) == undefined) {
                Async.GTaskManager.on("init", registerClass, (o) => {
                    $.content($("#main")).notification("add", {
                        title: "jres:33000242",
                        content: "jres:33000244", //RC 33000244 : Probíhá nahrávání licenčního certifikátu.
                        icon: "fa-info-circle",
                        state: "info",
                        id: "loadLicCertProgress"
                    })
                })
                Async.GTaskManager.on("done", registerClass, (o) => {
                    $.content($("#main")).notification("remove", "loadLicCertProgress");
                    var action = new GAction({
                        name: "actTest",
                        caption: "jres:33000245", //RC 33000245 : Klikněte pro zobrazení načtených licencí
                        icon: "fa-external-link",
                        run: (ev, ctx) => {
                            $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmObsahLicCert"], { Id: "SeznamAdmObsahLicCert" });
                            $.content($("#main")).notification("remove", "loadCertOk");
                        }
                    })

                    $.content().notification("add", {
                        title: "jres:33000242",
                        content: "jres:33000246", //RC 33000246 : Načtení licenčního certifikátu proběhlo úspěšně.
                        icon: "fa-info-circle",
                        state: "success",
                        id: "loadCertOk",
                        defaultAction: action,
                        commandBar: [
                            {
                                action: action
                            }
                        ]
                    })
                })
                Async.GTaskManager.on("fail", registerClass, (o) => {
                    var not: IGNotificationOptions = {
                        title: "jres:33000242", 
                        content: "jres:33000240", //RC 33000225 : Pokud je zdrojem soubor, zkontrolujte zda je opravdu vybrán soubor s logy.
                        icon: "fa-times-circle",
                        state: "error",
                    }
                    $.content($("#main")).notification("add", not);
                })
            }
        }
    }
}